/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorCreateCompositionsMutationRequest, VideoEditorCreateCompositionsMutationResponse, VideoEditorCreateCompositions401, VideoEditorCreateCompositions403 } from "../models/VideoEditorCreateCompositions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { videoEditorCreateCompositions } from "../axios/videoEditorCreateCompositions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const videoEditorCreateCompositionsMutationKey = () => [{ url: '/video-editor/v1/compositions' }] as const

export type VideoEditorCreateCompositionsMutationKey = ReturnType<typeof videoEditorCreateCompositionsMutationKey>

export function videoEditorCreateCompositionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<VideoEditorCreateCompositionsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = videoEditorCreateCompositionsMutationKey()
        return mutationOptions<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, {data: VideoEditorCreateCompositionsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return videoEditorCreateCompositions(data, config)
          },
        })

}

/**
 * @summary Create a single Composition
 * {@link /video-editor/v1/compositions}
 */
export function useVideoEditorCreateCompositions<TContext>(options: 
{
  mutation?: UseMutationOptions<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, {data: VideoEditorCreateCompositionsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<VideoEditorCreateCompositionsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? videoEditorCreateCompositionsMutationKey()

          const baseOptions = videoEditorCreateCompositionsMutationOptions(config) as UseMutationOptions<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, {data: VideoEditorCreateCompositionsMutationRequest}, TContext>
          

          return useMutation<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, {data: VideoEditorCreateCompositionsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<VideoEditorCreateCompositionsMutationResponse, ResponseErrorConfig<VideoEditorCreateCompositions401 | VideoEditorCreateCompositions403>, {data: VideoEditorCreateCompositionsMutationRequest}, TContext>
      
}